import "./footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-brand">
          <div className="logo">
            <div className="logo-box">S</div>

            <div>
              <h3>Strategic Accounting</h3>
              <span>MANAGEMENT • HOUSTON</span>
            </div>
          </div>

          <p>
            Professional Accounting • Bookkeeping • Payroll • Tax
            Support • CFO Advisory. Serving Houston businesses and
            clients nationwide.
          </p>
        </div>

        <div className="footer-column">
          <h4>CONTACT</h4>

          <a href="mailto:info@yourdomain.com">
            info@yourdomain.com
          </a>

          <p>(713) XXX-XXXX</p>

          <p>Houston, Texas</p>
        </div>

        <div className="footer-column">
          <h4>BUSINESS HOURS</h4>

          <p>Monday – Friday</p>

          <p>8:00 AM – 6:00 PM</p>
        </div>

      </div>

      <div className="footer-bottom">

        <p>
          © 2025 Strategic Accounting Management Houston. All rights
          reserved.
        </p>

        <span>
          Trusted Financial Partner · For Houston, TX
        </span>

      </div>
    </footer>
  );
}

export default Footer;